
const Disclaimer = () => (
  <main>
    <section className="hero-section centered games">
      <div className="w-container">
        <h1 className="hero-heading">Disclaimer</h1>
      </div>
    </section>

    <section className="section">
      <div className="w-container">
        <p className="paragraph-19">
          Welcome to <strong>LottoDreamingAU</strong>. Please read the following disclaimers carefully before using our website.<br /><br />
          
          <strong>1. No Real Money Gambling<br /></strong>
          <strong>LottoDreamingAU</strong> is a <strong>social casino platform</strong> created for <strong>entertainment purposes only</strong>. No real money or monetary prizes can be won. The games on this platform are purely recreational and do <strong>not</strong> involve any form of real-money gambling.<br /><br />

          <strong>2. No Guarantee of Future Gambling Success<br /></strong>
          Playing our games <strong>does not imply or guarantee</strong> success in real-money gambling. The outcomes of our games are <strong>random and based on chance</strong>, with no influence on any real-money gambling activities.<br /><br />

          <strong>3. Age Restriction<br /></strong>
          This platform is intended for users <strong>18 years and older</strong>. By accessing <strong>LottoDreamingAU</strong>, you confirm that you meet this age requirement. We reserve the right to <strong>restrict access</strong> to users who do not comply with this policy.<br /><br />

          <strong>4. Intellectual Property & Third-Party Rights<br /></strong>
          All <strong>game designs, trademarks, and content</strong> on this website are the <strong>intellectual property of LottoDreamingAU or its licensors</strong>. Unauthorized use, reproduction, or distribution of any material from this site is strictly prohibited.<br /><br />

          <strong>5. Responsible Gaming & Self-Exclusion<br /></strong>
          We support <strong>responsible gaming</strong> and encourage all users to play in moderation. If you believe gaming is negatively affecting your life, please take a break or seek professional support from organizations such as <a href="https://www.peluuri.fi/" target="_blank" rel="noopener noreferrer"><strong>Peluuri.fi</strong></a>.<br /><br />

          <strong>6. Liability Limitation<br /></strong>
          <strong>LottoDreamingAU</strong> is <strong>not responsible</strong> for any <strong>losses, damages, or other consequences</strong> resulting from the use of this website. All services are provided <strong>"as is"</strong>, without warranties or guarantees of uninterrupted or error-free operation.<br /><br />

          <strong>7. Google Ads & Third-Party Disclaimer<br /></strong>
          This website is <strong>independent</strong> and <strong>not affiliated with or endorsed by Google</strong> or any real-money gambling operators. Advertisements displayed on this platform are for <strong>informational purposes only</strong> and do not constitute an endorsement.
        </p>
      </div>
    </section>
  </main>
);

export default Disclaimer;
